// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   HERO SECTION - Modern Clean Design
   ============================================ */

/* Typography & Colors */
:root {
  --hero-bg: #ffffff;
  --hero-primary: #0d141b;
  --hero-accent: #f97316;
  --hero-text: #475569;
  --hero-success: #16a34a;
  --hero-shadow: rgba(0, 0, 0, 0.08);
  
  --font-display: "Lexend", system-ui, -apple-system, sans-serif;
  --font-body: "Noto Sans", system-ui, -apple-system, sans-serif;
}

/* ============================================
   MAIN HERO SECTION
   ============================================ */

.hero {
  position: relative;
  width: 100%;
  min-height: 90vh;
  background: #ffffff !important;
  display: flex;
  align-items: center;
  padding: 0 0 4rem;
  margin-top: -1px;
}

.hero__container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
  background: transparent;
}

.hero__grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 3rem;
  align-items: center;
  background: transparent;
}

/* ============================================
   CONTENT AREA (LEFT SIDE)
   ============================================ */

.hero__content {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  background: transparent;
}

/* Main Title */
.hero__h1 {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin: 0 0 0.75rem 0;
  color: #370b3b;
}

.hero__title {
  font-family: var(--font-display);
  font-size: 4.5rem;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.02em;
  margin: 0 0 1.5rem 0;
  text-transform: uppercase;
  
  /* Professional purple color matching S-CUBUS brand */
  color: #370b3b;
  
  /* Subtle text shadow for depth */
  text-shadow: 
    2px 2px 0px rgba(55, 11, 59, 0.1),
    0 4px 12px rgba(55, 11, 59, 0.15);
  
  /* Underline accent */
  position: relative;
  display: inline-block;
  padding-bottom: 0.5rem;
}

/* Professional underline accent */
.hero__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60%;
  height: 6px;
  background: linear-gradient(90deg, #f97316 0%, #fb923c 100%);
  border-radius: 3px;
}

/* Hindi Quote */
.hero__quote {
  font-family: var(--font-display);
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1.65;
  color: #ff5722;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-style: normal;
  text-align: left;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  box-shadow: none;
}

/* English Tagline */
.hero__tagline {
  font-family: var(--font-body);
  font-size: 1.15rem;
  line-height: 1.75;
  color: var(--hero-text);
  margin: 0;
  max-width: 100%;
}

/* Features/Badges */
.hero__features {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 0.5rem;
}

.hero__feature {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.hero__feature-icon {
  width: 32px;
  height: 32px;
  background: var(--hero-success);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
  flex-shrink: 0;
}

.hero__feature-text {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--hero-primary);
}

/* ============================================
   VISUAL AREA (RIGHT SIDE - SATHI IMAGE)
   ============================================ */

.hero__visual {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background: transparent;
  position: relative;
  z-index: 1;
}

.hero__image-link-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
}

.hero__image-link-overlay:hover ~ .hero__live-indicator,
.hero__image-wrapper:hover .hero__live-indicator {
  /* Keep live indicator visible on hover */
}

.hero__image-wrapper {
  position: relative;
  width: 100%;
  max-width: 600px;
  aspect-ratio: 1;
  background: #ffffff;
  border-radius: 32px;
  border: 3px solid #000000;
  box-shadow: 0 20px 60px var(--hero-shadow);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s ease;
  animation: float-animation 4s ease-in-out infinite;
}

@keyframes float-animation {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.hero__image-link-overlay:hover ~ .hero__image-wrapper {
  transform: translateY(-8px) scale(1.02);
  border: 4px solid #000000;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);
  animation: none;
}

.hero__image-wrapper:hover {
  transform: translateY(-8px) scale(1.02);
  border: 4px solid #000000;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);
  animation: none;
}

.hero__image {
  width: 155%;
  height: 155%;
  object-fit: contain;
  transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  pointer-events: none;
}

.hero__image-link-overlay:hover .hero__image {
  transform: scale(1.08);
}

/* Live Indicator Container */
.hero__live-indicator {
  position: absolute;
  top: 25px;
  right: 25px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(22, 163, 74, 0.95);
  padding: 0.5rem 0.875rem;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
  z-index: 20;
  pointer-events: none;
}

/* Click Hint - Shows on hover */
.hero__click-hint {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: linear-gradient(135deg, #370b3b 0%, #6b21a8 100%);
  color: white;
  padding: 0.65rem 1.25rem;
  border-radius: 25px;
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 15;
  white-space: nowrap;
  display: inline-block;
  line-height: 1.2;
}

.hero__image-link-overlay:hover .hero__click-hint {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* Notification Dot - Blinking Green Indicator */
.hero__notification-dot {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 
    0 0 0 0 rgba(255, 255, 255, 0.7);
  animation: pulse-dot 2s ease-in-out infinite;
  flex-shrink: 0;
}

/* Live Text */
.hero__live-text {
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.05em;
  line-height: 1;
}

@keyframes pulse-dot {
  0%, 100% {
    box-shadow: 
      0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  50% {
    box-shadow: 
      0 0 0 6px rgba(255, 255, 255, 0);
  }
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

/* Large Tablets */
@media (max-width: 1200px) {
  .hero__grid {
    gap: 4rem;
  }

  .hero__h1 {
    font-size: 1.35rem;
  }

  .hero__title {
    font-size: 3.5rem;
  }

  .hero__image-wrapper {
    max-width: 500px;
  }
}

/* Tablets & Below */
@media (max-width: 968px) {
  .hero {
    min-height: auto;
    padding: 0.5rem 0 3rem;
  }

  .hero__container {
    padding: 0 1.5rem;
  }

  .hero__grid {
    grid-template-columns: 1fr;
    gap: 3.5rem;
  }

  .hero__visual {
    padding: 1rem;
  }

  .hero__image-wrapper {
    max-width: 450px;
  }

  .hero__h1 {
    font-size: 1.25rem;
  }

  .hero__title {
    font-size: 3rem;
  }

  .hero__quote {
    font-size: 1.4rem;
  }

  .hero__tagline {
    font-size: 1.05rem;
    max-width: 100%;
  }
}

/* Mobile */
@media (max-width: 640px) {
  .hero {
    padding: 0.25rem 0 2rem;
    min-height: auto;
  }

  .hero__container {
    padding: 0 1rem;
  }

  .hero__grid {
    gap: 2rem;
  }

  .hero__visual {
    padding: 0.5rem;
  }

  .hero__h1 {
    font-size: 1.15rem;
    margin: 0 0 0.5rem 0;
  }

  .hero__title {
    font-size: 3.25rem;
    padding-bottom: 0.4rem;
    margin: 0 0 1.25rem 0;
  }

  .hero__title::after {
    height: 5px;
    width: 65%;
  }

  .hero__quote {
    font-size: 1.4rem;
    line-height: 1.6;
  }

  .hero__tagline {
    font-size: 1.05rem;
  }

  .hero__features {
    gap: 1.25rem;
  }

  .hero__feature-icon {
    width: 26px;
    height: 26px;
    font-size: 0.75rem;
  }

  .hero__feature-text {
    font-size: 0.9rem;
  }

  .hero__image-wrapper {
    max-width: 100%;
    aspect-ratio: 1;
    border-radius: 24px;
  }

  .hero__image {
    width: 150%;
    height: 150%;
  }
  
  .hero__live-indicator {
    top: 12px;
    right: 12px;
    padding: 0.4rem 0.7rem;
  }
  
  .hero__notification-dot {
    width: 10px;
    height: 10px;
  }
  
  .hero__live-text {
    font-size: 0.75rem;
  }

  .hero__click-hint {
    font-size: 0.8rem;
    padding: 0.55rem 1rem;
    bottom: 12px;
  }
}

/* Small Mobile / Android Phones */
@media (max-width: 480px) {
  .hero {
    padding: 0 0 1.5rem;
  }

  .hero__container {
    padding: 0 0.875rem;
  }

  .hero__grid {
    gap: 1.75rem;
  }

  .hero__h1 {
    font-size: 1rem;
    margin: 0 0 0.4rem 0;
  }

  .hero__title {
    font-size: 2.75rem;
    margin: 0 0 1rem 0;
  }

  .hero__quote {
    font-size: 1.15rem;
    line-height: 1.55;
  }

  .hero__tagline {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .hero__features {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.875rem;
  }

  .hero__image-wrapper {
    border-radius: 20px;
  }
  
  .hero__live-indicator {
    top: 10px;
    right: 10px;
    padding: 0.35rem 0.6rem;
  }
  
  .hero__notification-dot {
    width: 8px;
    height: 8px;
  }
  
  .hero__live-text {
    font-size: 0.7rem;
  }

  .hero__click-hint {
    font-size: 0.75rem;
    padding: 0.45rem 0.85rem;
    bottom: 10px;
  }
}

/* Extra Small Android Devices */
@media (max-width: 375px) {
  .hero__title {
    font-size: 1.75rem;
  }

  .hero__quote {
    font-size: 0.9rem;
  }

  .hero__tagline {
    font-size: 0.85rem;
  }

  .hero__feature-text {
    font-size: 0.85rem;
  }
}

/* ============================================
   DARK MODE SUPPORT
   ============================================ */

html[data-theme="dark"] .hero {
  background: #0a0a0f;
}

html[data-theme="dark"] .hero__title {
  color: #ffffff;
}

html[data-theme="dark"] .hero__quote {
  color: #fbbf24;
}

html[data-theme="dark"] .hero__tagline {
  color: #cbd5e1;
}

html[data-theme="dark"] .hero__feature-text {
  color: #e2e8f0;
}

html[data-theme="dark"] .hero__image-wrapper {
  background: #1a1a24;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Hero/hero.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,wBAAwB;AACxB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;;EAElC,8DAA8D;EAC9D,8DAA8D;AAChE;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;;EAEzB,qDAAqD;EACrD,cAAc;;EAEd,iCAAiC;EACjC;;qCAEmC;;EAEnC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,4CAA4C;EAC5C,6DAA6D;EAC7D,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB;oCACkC;EAClC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE;sCACkC;EACpC;EACA;IACE;sCACkC;EACpC;AACF;;AAEA;;iDAEiD;;AAEjD,kBAAkB;AAClB;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB;;uCAEqC;AACvC","sourcesContent":["/* ============================================\r\n   HERO SECTION - Modern Clean Design\r\n   ============================================ */\r\n\r\n/* Typography & Colors */\r\n:root {\r\n  --hero-bg: #ffffff;\r\n  --hero-primary: #0d141b;\r\n  --hero-accent: #f97316;\r\n  --hero-text: #475569;\r\n  --hero-success: #16a34a;\r\n  --hero-shadow: rgba(0, 0, 0, 0.08);\r\n  \r\n  --font-display: \"Lexend\", system-ui, -apple-system, sans-serif;\r\n  --font-body: \"Noto Sans\", system-ui, -apple-system, sans-serif;\r\n}\r\n\r\n/* ============================================\r\n   MAIN HERO SECTION\r\n   ============================================ */\r\n\r\n.hero {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 90vh;\r\n  background: #ffffff !important;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 0 4rem;\r\n  margin-top: -1px;\r\n}\r\n\r\n.hero__container {\r\n  width: 100%;\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n  background: transparent;\r\n}\r\n\r\n.hero__grid {\r\n  display: grid;\r\n  grid-template-columns: 1.2fr 1fr;\r\n  gap: 3rem;\r\n  align-items: center;\r\n  background: transparent;\r\n}\r\n\r\n/* ============================================\r\n   CONTENT AREA (LEFT SIDE)\r\n   ============================================ */\r\n\r\n.hero__content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.75rem;\r\n  background: transparent;\r\n}\r\n\r\n/* Main Title */\r\n.hero__h1 {\r\n  font-family: var(--font-display);\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  letter-spacing: -0.01em;\r\n  margin: 0 0 0.75rem 0;\r\n  color: #370b3b;\r\n}\r\n\r\n.hero__title {\r\n  font-family: var(--font-display);\r\n  font-size: 4.5rem;\r\n  font-weight: 900;\r\n  line-height: 1;\r\n  letter-spacing: -0.02em;\r\n  margin: 0 0 1.5rem 0;\r\n  text-transform: uppercase;\r\n  \r\n  /* Professional purple color matching S-CUBUS brand */\r\n  color: #370b3b;\r\n  \r\n  /* Subtle text shadow for depth */\r\n  text-shadow: \r\n    2px 2px 0px rgba(55, 11, 59, 0.1),\r\n    0 4px 12px rgba(55, 11, 59, 0.15);\r\n  \r\n  /* Underline accent */\r\n  position: relative;\r\n  display: inline-block;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n/* Professional underline accent */\r\n.hero__title::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 60%;\r\n  height: 6px;\r\n  background: linear-gradient(90deg, #f97316 0%, #fb923c 100%);\r\n  border-radius: 3px;\r\n}\r\n\r\n/* Hindi Quote */\r\n.hero__quote {\r\n  font-family: var(--font-display);\r\n  font-size: 1.65rem;\r\n  font-weight: 700;\r\n  line-height: 1.65;\r\n  color: #ff5722;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  background: none;\r\n  font-style: normal;\r\n  text-align: left;\r\n  max-width: 100%;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  box-shadow: none;\r\n}\r\n\r\n/* English Tagline */\r\n.hero__tagline {\r\n  font-family: var(--font-body);\r\n  font-size: 1.15rem;\r\n  line-height: 1.75;\r\n  color: var(--hero-text);\r\n  margin: 0;\r\n  max-width: 100%;\r\n}\r\n\r\n/* Features/Badges */\r\n.hero__features {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.hero__feature {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.hero__feature-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  background: var(--hero-success);\r\n  color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.hero__feature-text {\r\n  font-family: var(--font-display);\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: var(--hero-primary);\r\n}\r\n\r\n/* ============================================\r\n   VISUAL AREA (RIGHT SIDE - SATHI IMAGE)\r\n   ============================================ */\r\n\r\n.hero__visual {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 2rem;\r\n  background: transparent;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.hero__image-link-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 5;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 32px;\r\n}\r\n\r\n.hero__image-link-overlay:hover ~ .hero__live-indicator,\r\n.hero__image-wrapper:hover .hero__live-indicator {\r\n  /* Keep live indicator visible on hover */\r\n}\r\n\r\n.hero__image-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 600px;\r\n  aspect-ratio: 1;\r\n  background: #ffffff;\r\n  border-radius: 32px;\r\n  border: 3px solid #000000;\r\n  box-shadow: 0 20px 60px var(--hero-shadow);\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.4s ease;\r\n  animation: float-animation 4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes float-animation {\r\n  0%, 100% {\r\n    transform: translateY(0px);\r\n  }\r\n  50% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n.hero__image-link-overlay:hover ~ .hero__image-wrapper {\r\n  transform: translateY(-8px) scale(1.02);\r\n  border: 4px solid #000000;\r\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);\r\n  animation: none;\r\n}\r\n\r\n.hero__image-wrapper:hover {\r\n  transform: translateY(-8px) scale(1.02);\r\n  border: 4px solid #000000;\r\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);\r\n  animation: none;\r\n}\r\n\r\n.hero__image {\r\n  width: 155%;\r\n  height: 155%;\r\n  object-fit: contain;\r\n  transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n  pointer-events: none;\r\n}\r\n\r\n.hero__image-link-overlay:hover .hero__image {\r\n  transform: scale(1.08);\r\n}\r\n\r\n/* Live Indicator Container */\r\n.hero__live-indicator {\r\n  position: absolute;\r\n  top: 25px;\r\n  right: 25px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(22, 163, 74, 0.95);\r\n  padding: 0.5rem 0.875rem;\r\n  border-radius: 50px;\r\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);\r\n  z-index: 20;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Click Hint - Shows on hover */\r\n.hero__click-hint {\r\n  position: absolute;\r\n  bottom: 15px;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(10px);\r\n  background: linear-gradient(135deg, #370b3b 0%, #6b21a8 100%);\r\n  color: white;\r\n  padding: 0.65rem 1.25rem;\r\n  border-radius: 25px;\r\n  font-family: var(--font-display);\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: all 0.3s ease;\r\n  z-index: 15;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  line-height: 1.2;\r\n}\r\n\r\n.hero__image-link-overlay:hover .hero__click-hint {\r\n  opacity: 1;\r\n  transform: translateX(-50%) translateY(0);\r\n}\r\n\r\n/* Notification Dot - Blinking Green Indicator */\r\n.hero__notification-dot {\r\n  width: 12px;\r\n  height: 12px;\r\n  background: #ffffff;\r\n  border-radius: 50%;\r\n  box-shadow: \r\n    0 0 0 0 rgba(255, 255, 255, 0.7);\r\n  animation: pulse-dot 2s ease-in-out infinite;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Live Text */\r\n.hero__live-text {\r\n  font-family: var(--font-display);\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  letter-spacing: 0.05em;\r\n  line-height: 1;\r\n}\r\n\r\n@keyframes pulse-dot {\r\n  0%, 100% {\r\n    box-shadow: \r\n      0 0 0 0 rgba(255, 255, 255, 0.7);\r\n  }\r\n  50% {\r\n    box-shadow: \r\n      0 0 0 6px rgba(255, 255, 255, 0);\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE DESIGN\r\n   ============================================ */\r\n\r\n/* Large Tablets */\r\n@media (max-width: 1200px) {\r\n  .hero__grid {\r\n    gap: 4rem;\r\n  }\r\n\r\n  .hero__h1 {\r\n    font-size: 1.35rem;\r\n  }\r\n\r\n  .hero__title {\r\n    font-size: 3.5rem;\r\n  }\r\n\r\n  .hero__image-wrapper {\r\n    max-width: 500px;\r\n  }\r\n}\r\n\r\n/* Tablets & Below */\r\n@media (max-width: 968px) {\r\n  .hero {\r\n    min-height: auto;\r\n    padding: 0.5rem 0 3rem;\r\n  }\r\n\r\n  .hero__container {\r\n    padding: 0 1.5rem;\r\n  }\r\n\r\n  .hero__grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 3.5rem;\r\n  }\r\n\r\n  .hero__visual {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .hero__image-wrapper {\r\n    max-width: 450px;\r\n  }\r\n\r\n  .hero__h1 {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .hero__title {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .hero__quote {\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  .hero__tagline {\r\n    font-size: 1.05rem;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 640px) {\r\n  .hero {\r\n    padding: 0.25rem 0 2rem;\r\n    min-height: auto;\r\n  }\r\n\r\n  .hero__container {\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .hero__grid {\r\n    gap: 2rem;\r\n  }\r\n\r\n  .hero__visual {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .hero__h1 {\r\n    font-size: 1.15rem;\r\n    margin: 0 0 0.5rem 0;\r\n  }\r\n\r\n  .hero__title {\r\n    font-size: 3.25rem;\r\n    padding-bottom: 0.4rem;\r\n    margin: 0 0 1.25rem 0;\r\n  }\r\n\r\n  .hero__title::after {\r\n    height: 5px;\r\n    width: 65%;\r\n  }\r\n\r\n  .hero__quote {\r\n    font-size: 1.4rem;\r\n    line-height: 1.6;\r\n  }\r\n\r\n  .hero__tagline {\r\n    font-size: 1.05rem;\r\n  }\r\n\r\n  .hero__features {\r\n    gap: 1.25rem;\r\n  }\r\n\r\n  .hero__feature-icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .hero__feature-text {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .hero__image-wrapper {\r\n    max-width: 100%;\r\n    aspect-ratio: 1;\r\n    border-radius: 24px;\r\n  }\r\n\r\n  .hero__image {\r\n    width: 150%;\r\n    height: 150%;\r\n  }\r\n  \r\n  .hero__live-indicator {\r\n    top: 12px;\r\n    right: 12px;\r\n    padding: 0.4rem 0.7rem;\r\n  }\r\n  \r\n  .hero__notification-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n  }\r\n  \r\n  .hero__live-text {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .hero__click-hint {\r\n    font-size: 0.8rem;\r\n    padding: 0.55rem 1rem;\r\n    bottom: 12px;\r\n  }\r\n}\r\n\r\n/* Small Mobile / Android Phones */\r\n@media (max-width: 480px) {\r\n  .hero {\r\n    padding: 0 0 1.5rem;\r\n  }\r\n\r\n  .hero__container {\r\n    padding: 0 0.875rem;\r\n  }\r\n\r\n  .hero__grid {\r\n    gap: 1.75rem;\r\n  }\r\n\r\n  .hero__h1 {\r\n    font-size: 1rem;\r\n    margin: 0 0 0.4rem 0;\r\n  }\r\n\r\n  .hero__title {\r\n    font-size: 2.75rem;\r\n    margin: 0 0 1rem 0;\r\n  }\r\n\r\n  .hero__quote {\r\n    font-size: 1.15rem;\r\n    line-height: 1.55;\r\n  }\r\n\r\n  .hero__tagline {\r\n    font-size: 0.95rem;\r\n    line-height: 1.6;\r\n  }\r\n\r\n  .hero__features {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.875rem;\r\n  }\r\n\r\n  .hero__image-wrapper {\r\n    border-radius: 20px;\r\n  }\r\n  \r\n  .hero__live-indicator {\r\n    top: 10px;\r\n    right: 10px;\r\n    padding: 0.35rem 0.6rem;\r\n  }\r\n  \r\n  .hero__notification-dot {\r\n    width: 8px;\r\n    height: 8px;\r\n  }\r\n  \r\n  .hero__live-text {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .hero__click-hint {\r\n    font-size: 0.75rem;\r\n    padding: 0.45rem 0.85rem;\r\n    bottom: 10px;\r\n  }\r\n}\r\n\r\n/* Extra Small Android Devices */\r\n@media (max-width: 375px) {\r\n  .hero__title {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  .hero__quote {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .hero__tagline {\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .hero__feature-text {\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   DARK MODE SUPPORT\r\n   ============================================ */\r\n\r\nhtml[data-theme=\"dark\"] .hero {\r\n  background: #0a0a0f;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hero__title {\r\n  color: #ffffff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hero__quote {\r\n  color: #fbbf24;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hero__tagline {\r\n  color: #cbd5e1;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hero__feature-text {\r\n  color: #e2e8f0;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .hero__image-wrapper {\r\n  background: #1a1a24;\r\n  box-shadow: \r\n    0 20px 60px rgba(0, 0, 0, 0.4),\r\n    0 0 0 1px rgba(255, 255, 255, 0.05);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
